var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FullPageIframe from './fullPage';
import PopupIframe from './popup';
var componentMap = {
    fullPage: FullPageIframe,
    popup: PopupIframe,
};
var Iframe = function (_a) {
    var variant = _a.variant, isOpen = _a.isOpen, rest = __rest(_a, ["variant", "isOpen"]);
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    useEffect(function () {
        if (!isOpen)
            setIsLoading(true);
    }, [isOpen]);
    var handleOnLoad = function () { return setIsLoading(false); };
    var Component = componentMap[variant !== null && variant !== void 0 ? variant : 'fullPage'];
    // eslint-disable-next-line react/jsx-props-no-spreading
    return React.createElement(Component, __assign({}, rest, { isOpen: isOpen, isLoading: isLoading, onLoad: handleOnLoad }));
};
Iframe.propTypes = {
    /** The id of the outer element. */
    id: PropTypes.string,
    /** A CSS class for the iframe element, in addition to the component's base classes. */
    className: PropTypes.string,
    /** An object with custom style applied to the iframe element. */
    style: PropTypes.object,
    /** The URL of the page to embed. */
    src: PropTypes.string,
    /** The title of the iframe, for accessibility. */
    title: PropTypes.string,
    /** Controls whether the Modal is opened or not. If true, the modal is open. */
    isOpen: PropTypes.bool,
    /** The header can include text or a component, and is displayed at the top of the component. */
    header: PropTypes.node,
    /** The variant of the iframe to show */
    variant: PropTypes.oneOf(['fullPage', 'popup']),
    /** The action triggered when the component request to close
     *  (e.g click close button). */
    onRequestClose: PropTypes.func,
};
Iframe.defaultProps = {
    id: undefined,
    className: undefined,
    style: undefined,
    src: undefined,
    title: undefined,
    header: undefined,
    isOpen: false,
    variant: 'fullPage',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onRequestClose: function () { },
};
export default Iframe;
//# sourceMappingURL=index.js.map